import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import FluidImage from 'components/FluidImage'
import Icon from 'components/Icon'
import fallbackImage from '../../assets/image-placeholder-light.svg'

const CARD_TYPES = {
    REPORT: "report",
    NEWS: "news"
}

const ArticleCard = ({
    id,
    categories,
    className,
    hasAccess,
    hasAccessLabel,
    intro,
    image,
    published,
    publishedFormatted,
    title,
    smallTitle,
    cardType,
    headingTagLevel = 3,
}) => {
    const HeadingTag = `h${headingTagLevel}`;

    return (
        <article
            className={cn('card', className, { 
                news: cardType === CARD_TYPES.NEWS,
                report: cardType === CARD_TYPES.REPORT
            })}
            data-id={id}
        >
            <div className="content">
                <header>
                    {smallTitle && <span className="small-title">{smallTitle}</span>}
                    <HeadingTag className='h2'>
                        {!hasAccess && <Icon use="key" />}
                        {title}
                    </HeadingTag>
                    {intro && (
                        <div
                            className="intro wysiwyg typo-small"
                            dangerouslySetInnerHTML={{
                                __html: intro.stripHtmlTags()
                            }}
                        />
                    )}
                </header>
                {(published || publishedFormatted || categories) && (
                    <div className="meta typo-small">
                        {published &&
                            publishedFormatted && (
                                <time dateTime={published}>
                                    {publishedFormatted}
                                </time>
                            )}
                        {categories && (
                            <span className="categories">{categories}</span>
                        )}
                    </div>
                )}
            </div>
            <div className="image">
                <FluidImage
                    {...image}
                    fallback={fallbackImage}
                    width={330}
                    height={290}
                />
                {!hasAccess && (
                    <div className="no-access">
                        <Icon use="key" />
                        <span
                            dangerouslySetInnerHTML={{ __html: hasAccessLabel }}
                        />
                    </div>
                )}
            </div>
        </article>
    )
}

ArticleCard.propTypes = {
    id: PropTypes.number,
    categories: PropTypes.string,
    className: PropTypes.string,
    hasAccess: PropTypes.bool.isRequired,
    hasAccessLabel: PropTypes.string.isRequired,
    image: PropTypes.exact(FluidImage.propTypes),
    intro: PropTypes.string,
    published: PropTypes.string,
    publishedFormatted: PropTypes.string,
    smallTitle: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string, // TODO:  Please note that link to article is out of ArticleCard itself(Legacy сode) and rendered in list components:  LatestArticlesBlock, InternationalMediaBlock, SearchResults, NewsFolder, StatisticsBlock
    headingTagLevel: PropTypes.oneOf([2, 3]),
    cardType: PropTypes.oneOf(Object.values(CARD_TYPES))
}

export default ArticleCard
